// extracted by mini-css-extract-plugin
export var brand = "_ba-9";
export var compact = "_ba-6";
export var extraSmall = "_ba-7";
export var icon = "_ba-0";
export var large = "_ba-4";
export var light = "_ba-1";
export var medium = "_ba-5";
export var outline = "_ba-b";
export var primaryDark = "_ba-a";
export var primaryLight = "_ba-8";
export var primaryModern = "_ba-c";
export var success = "_ba-2";
export var successSolid = "_ba-3";